import { useContext, useEffect, useState } from 'react';
import { GetAuthServices, GLAuthContext } from '../../../Services/AuthService/AuthService';
import { LoadingBlock } from '../../../AppRoutes/Journal/SharedComponents';
import { appInsights } from '../../../Services/AppInsightsService';




const doLogging = false;
export function LoginPage() {
    const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined); // Initialize the error message state
    const authContext = useContext(GLAuthContext);



    const AddTimeStamp = (str: string) => {
        return new Date().toISOString() + " | " + str;
    }


    useEffect(() => {

        doLogging && console.log(AddTimeStamp("Checking if we are logged in..."), authContext);
        if (authContext?.isLoggedIn) {
            doLogging && console.log("We are logged in...");

        }
        else {
            const handleLogin = async () => {
                try {
                    const authServices = await GetAuthServices();
                    await authServices!.LoginUser();
                } catch (e: any) {
                    setErrorMessage(e.message); // Set the error message state
                }
            };
            handleLogin();
        }

        appInsights.trackTrace({ message: "LoginPage", properties: { isLoggedIn: authContext?.isLoggedIn } });

    }, [authContext?.isLoggedIn]);

    return (
        <>
            <LoadingBlock showLogo />
            {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>} {/* Display error message */}
        </>
    );

}

